import React, { useState, useEffect } from "react";
import { FormControlLabel, Checkbox, Radio, RadioGroup } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ApiServices from "../../services/apiServices";
import { toast } from "react-toastify";
import { useLoad } from "../../context";
import { Scale } from "@mui/icons-material";

export default function PesquisaResponder() {
  const [listaPesquisa, setListaPesquisa] = useState({});
  const [temResposta, setTemResposta] = useState(false);
  const [respostas, setRespostas] = useState({});
  const [perguntasVisiveis, setPerguntasVisiveis] = useState(new Set());
  const { load, setLoad } = useLoad();
  const params = useParams();
  const navigate = useNavigate();
  const [js, setJs] = useState([
    {
      id: 0,
      nome: 0,
      cores: "#a72827",
    },
    {
      id: 1,
      nome: 1,
      cores: "#c4282c",
    },
    {
      id: 2,
      nome: 2,
      cores: "#df5227",
    },
    {
      id: 3,
      nome: 3,
      cores: "#d87329",
    },
    {
      id: 4,
      nome: 4,
      cores: "#eba72d",
    },
    {
      id: 5,
      nome: 5,
      cores: "#f1c734",
    },
    {
      id: 6,
      nome: 6,
      cores: "#e3de50",
    },
    {
      id: 7,
      nome: 7,
      cores: "#c3d13c",
    },
    {
      id: 8,
      nome: 8,
      cores: "#b1c845",
    },
    {
      id: 9,
      nome: 9,
      cores: "#b1c845",
    },
    {
      id: 10,
      nome: 10,
      cores: "#78b44e",
    },
  ]);

  const calcularPerguntasVisiveis = (pesquisa, respostasAtuais) => {
    const perguntasVisiveis = new Set();
    const perguntasOrdenadas = [...(pesquisa?.perguntas || [])].sort((a, b) => a.ordem - b.ordem);
    
    if (perguntasOrdenadas.length === 0) return perguntasVisiveis;
    
    // Mapa para facilitar busca de perguntas por ID
    const mapaPerguntas = new Map();
    perguntasOrdenadas.forEach((p, index) => {
      mapaPerguntas.set(p.id, index);
    });
    
    // Função auxiliar para verificar se uma pergunta deve ser ocultada
    const deveOcultarPergunta = (perguntaId, perguntaIndex) => {
      // Percorre todas as perguntas condicionais respondidas
      for (let i = 0; i < perguntasOrdenadas.length; i++) {
        const pergunta = perguntasOrdenadas[i];
        
        if (pergunta.tipo === 15 && 
            pergunta.condicional && 
            respostasAtuais[pergunta.id]?.respostaCondicional !== undefined) {
          
          const resposta = respostasAtuais[pergunta.id].respostaCondicional;
          const cond = pergunta.condicional;
          const condIndex = i;
          
          // Se a pergunta está antes ou na mesma posição da condicional, sempre mostra
          if (perguntaIndex <= condIndex) continue;
          
          if (!cond.pularParaPerguntaSeSimId || !cond.pularParaPerguntaSeNaoId) continue;
          
          const simIndex = mapaPerguntas.get(cond.pularParaPerguntaSeSimId);
          const noIndex = mapaPerguntas.get(cond.pularParaPerguntaSeNaoId);
          
          if (simIndex === undefined || noIndex === undefined) continue;
          
          // Se resposta é SIM
          if (resposta === true) {
            // Se PularPerguntasDoNao = true, oculta perguntas a partir de PularParaPerguntaSeNaoId
            // Exemplo: se noIndex = 5 (pergunta 6), oculta a partir do índice 5
            if (cond.pularPerguntasDoNao && perguntaIndex >= noIndex) {
              return true;
            }
            // Se PularPerguntasDoNao = false, mostra todas (não oculta nada)
          }
          
          // Se resposta é NÃO
          if (resposta === false) {
            // Comportamento quando NÃO:
            // - Se PularPerguntasDoSim = true: sempre oculta entre simIndex e noIndex
            // - Se PularPerguntasDoSim = false E PularPerguntasDoNao = true: não oculta nada (mostra tudo)
            // - Se PularPerguntasDoSim = false E PularPerguntasDoNao = false: oculta entre simIndex e noIndex (comportamento padrão)
            
            // Se PularPerguntasDoSim = true, oculta perguntas entre PularParaPerguntaSeSimId e PularParaPerguntaSeNaoId
            if (cond.pularPerguntasDoSim) {
              // Ocultar perguntas de simIndex até noIndex (excluindo noIndex)
              if (perguntaIndex >= simIndex && perguntaIndex < noIndex) {
                return true;
              }
            } else {
              // PularPerguntasDoSim = false
              // Se PularPerguntasDoNao = true, não oculta nada (mostra tudo)
              if (cond.pularPerguntasDoNao) {
                // Não oculta nada quando NÃO, PularPerguntasDoSim = false e PularPerguntasDoNao = true
                return false;
              } else {
                // Ambos false: comportamento padrão - oculta entre simIndex e noIndex
                if (perguntaIndex >= simIndex && perguntaIndex < noIndex) {
                  return true;
                }
              }
            }
          }
        }
      }
      return false;
    };
    
    // Percorre perguntas em ordem e adiciona as visíveis
    for (let i = 0; i < perguntasOrdenadas.length; i++) {
      const pergunta = perguntasOrdenadas[i];
      
      // Se é a primeira pergunta, sempre adiciona
      if (i === 0) {
        perguntasVisiveis.add(pergunta.id);
        continue;
      }
      
      // Verifica se há uma pergunta condicional anterior não respondida que bloqueia esta
      let bloqueadaPorCondicional = false;
      for (let j = 0; j < i; j++) {
        const perguntaAnterior = perguntasOrdenadas[j];
        
        // Se encontrou uma condicional não respondida antes desta pergunta
        if (perguntaAnterior.tipo === 15 && 
            perguntaAnterior.condicional &&
            respostasAtuais[perguntaAnterior.id]?.respostaCondicional === undefined) {
          
          // Se encontrou uma condicional não respondida, para de adicionar perguntas
          // (a própria condicional já foi adicionada, mas as seguintes não)
          bloqueadaPorCondicional = true;
          break;
        }
      }
      
      // Se está bloqueada por condicional não respondida, não adiciona
      if (bloqueadaPorCondicional) {
        continue;
      }
      
      // Se não está bloqueada, verifica se deve ocultar baseado nas respostas condicionais
      if (!deveOcultarPergunta(pergunta.id, i)) {
        perguntasVisiveis.add(pergunta.id);
      }
    }
    
    return perguntasVisiveis;
  };

  async function carregarPesquisa() {
    setLoad(true);
    try {
      const response = await ApiServices.apiGet(`pesquisa/${params.id}`);
      setListaPesquisa(response.data);
      await carregarDetalhePesquisa(response.data);
    } catch (err) {
      console.error("Erro ao carregar a pesquisa:", err);
      toast.error("Erro ao carregar a pesquisa.");
    } finally {
      setLoad(false);
    }
  }

  async function carregarDetalhePesquisa(pesquisaData) {
    setLoad(true);
    try {
      const response = await ApiServices.apiGet(
        `pesquisa/resposta-detalhe/${params.id}`
      );
      setTemResposta(response?.data?.perguntas?.length > 0);
      const novasRespostas = {};

      response?.data?.perguntas.forEach((pergunta) => {
        if (pergunta.tipo === 11 || pergunta.tipo === 10) {
          novasRespostas[pergunta.id] = {
            opcoes: pergunta.opcoes.map((opcao) => opcao.opcaoId),
          };
        } else if (pergunta.tipo === 15) {
          // Para tipo 15, verifica se há resposta condicional
          const respostaCondicional = pergunta.respostas?.[0]?.respostaCondicional;
          if (respostaCondicional !== undefined) {
            novasRespostas[pergunta.id] = {
              respostaCondicional: respostaCondicional
            };
          }
        } else if (pergunta.tipo === 14) {
          // Para tipo 14, carrega as classificações das opções
          // Verifica se há classificações nas respostas
          const classificacoes = {};

          // Primeiro, tenta buscar nas respostas diretas
          if (pergunta.respostas && pergunta.respostas.length > 0) {
            pergunta.respostas.forEach((resposta) => {
              if (resposta.classificacoes) {
                Object.assign(classificacoes, resposta.classificacoes);
              }
            });
          }

          // Verifica se há classificações diretamente na pergunta
          if (pergunta.classificacoes) {
            Object.assign(classificacoes, pergunta.classificacoes);
          }

          // Verifica se há classificações em outros campos possíveis
          if (pergunta.respostaClassificacao) {
            Object.assign(classificacoes, pergunta.respostaClassificacao);
          }

          if (pergunta.ordemClassificacao) {
            Object.assign(classificacoes, pergunta.ordemClassificacao);
          }

          // Se não encontrou classificações nas respostas, tenta usar a ordem das opções
          if (Object.keys(classificacoes).length === 0) {
            // Para tipo 14, se as opções estão ordenadas, significa que foi respondida
            // A ordem na lista é a prioridade (índice + 1)
            pergunta.opcoes.forEach((opcao, index) => {
              classificacoes[opcao.opcaoId] = index + 1;
            });
          }

          if (Object.keys(classificacoes).length > 0) {
            novasRespostas[pergunta.id] = {
              classificacoes: classificacoes,
            };
          }
        }

        // Processa respostas existentes (texto, escala, etc.)
        pergunta.respostas.forEach((resposta) => {
          if (resposta.texto || resposta.escala) {
            novasRespostas[pergunta.id] = {
              ...novasRespostas[pergunta.id],
              texto: resposta.texto,
              escala: resposta.escala,
            };
          }
        });
      });

      setRespostas(novasRespostas);

      // Recalcular perguntas visíveis após carregar respostas usando pesquisaData
      const visiveisAtualizadas = calcularPerguntasVisiveis(pesquisaData, novasRespostas);
      setPerguntasVisiveis(visiveisAtualizadas);
    } catch (err) {
      console.error("Erro ao carregar a pesquisa:", err);
      toast.error("Erro ao carregar a pesquisa.");
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    carregarPesquisa();
  }, [params.id, setLoad]);

  // Recalcula perguntas visíveis sempre que as respostas mudarem
  useEffect(() => {
    if (listaPesquisa?.perguntas && listaPesquisa.perguntas.length > 0) {
      const visiveisAtualizadas = calcularPerguntasVisiveis(listaPesquisa, respostas);
      setPerguntasVisiveis(visiveisAtualizadas);
    }
  }, [respostas, listaPesquisa]);

  const handleCheckboxChange = (perguntaId, opcaoId, isChecked) => {
    setRespostas((prev) => {
      const respostasAtuais = prev[perguntaId]?.opcoes || [];
      const novasOpcoes = isChecked
        ? [...respostasAtuais, opcaoId]
        : respostasAtuais.filter((id) => id !== opcaoId);

      return {
        ...prev,
        [perguntaId]: { opcoes: novasOpcoes },
      };
    });
  };

  // Função para verificar se um checkbox deve estar desabilitado
  const isCheckboxDisabled = (pergunta, opcaoId) => {
    if (temResposta) return true;

    // Se não tem limite de resposta, não desabilita
    if (!pergunta.temLimiteResposta || !pergunta.limiteResposta) return false;

    const respostasAtuais = respostas[pergunta.id]?.opcoes || [];
    const estaSelecionado = respostasAtuais.includes(opcaoId);

    // Se está selecionado, nunca desabilita
    if (estaSelecionado) return false;

    // Se atingiu o limite, desabilita os não selecionados
    return respostasAtuais.length >= pergunta.limiteResposta;
  };

  const handleRadioChange = (perguntaId, opcaoId) => {
    setRespostas((prev) => ({
      ...prev,
      [perguntaId]: { opcoes: [opcaoId] },
    }));
  };

  const handleTextareaChange = (perguntaId, texto) => {
    setRespostas((prev) => ({
      ...prev,
      [perguntaId]: { texto },
    }));
  };

  const handleEscalaChange = (perguntaId, valorEscala) => {
    setRespostas((prev) => ({
      ...prev,
      [perguntaId]: { escala: valorEscala },
    }));
  };

  // Função para gerenciar classificações (tipo 14)
  const handleClassificacaoChange = (perguntaId, opcaoId) => {
    setRespostas((prev) => {
      const classificacoesAtuais = prev[perguntaId]?.classificacoes || {};
      const proximaPrioridade = Object.keys(classificacoesAtuais).length + 1;

      // Se a opção já está classificada, remove a classificação
      if (classificacoesAtuais[opcaoId]) {
        const novasClassificacoes = { ...classificacoesAtuais };
        delete novasClassificacoes[opcaoId];

        // Reorganiza as prioridades
        const opcoesOrdenadas = Object.entries(novasClassificacoes)
          .sort(([, a], [, b]) => a - b)
          .reduce((acc, [opcaoId, prioridade], index) => {
            acc[opcaoId] = index + 1;
            return acc;
          }, {});

        return {
          ...prev,
          [perguntaId]: { classificacoes: opcoesOrdenadas },
        };
      }

      // Adiciona nova classificação
      return {
        ...prev,
        [perguntaId]: {
          classificacoes: {
            ...classificacoesAtuais,
            [opcaoId]: proximaPrioridade,
          },
        },
      };
    });
  };

  // Função para obter a prioridade de uma opção
  const getPrioridade = (perguntaId, opcaoId) => {
    return respostas[perguntaId]?.classificacoes?.[opcaoId] || null;
  };

  // Função para gerenciar perguntas condicionais (tipo 15)
  const handleCondicionalChange = (perguntaId, valor) => {
    setRespostas((prev) => {
      const novasRespostas = { ...prev };
      novasRespostas[perguntaId] = { respostaCondicional: valor };
      
      // Recalcular perguntas visíveis
      const novasVisiveis = calcularPerguntasVisiveis(listaPesquisa, novasRespostas);
      
      // Limpar respostas de perguntas que ficaram ocultas
      const perguntasOcultas = Object.keys(prev).filter(id => !novasVisiveis.has(id));
      perguntasOcultas.forEach(id => {
        delete novasRespostas[id];
      });
      
      setPerguntasVisiveis(novasVisiveis);
      
      return novasRespostas;
    });
  };

  // Função para verificar se todas as prioridades estão marcadas para tipo 14
  const verificarPrioridadesCompletas = () => {
    const perguntasTipo14 =
      listaPesquisa?.perguntas?.filter((p) => p.tipo === 14) || [];

    for (const pergunta of perguntasTipo14) {
      const classificacoes = respostas[pergunta.id]?.classificacoes || {};
      const opcoesClassificadas = Object.keys(classificacoes).length;
      const totalOpcoes = pergunta.opcoes.length;

      // Se não tem todas as opções classificadas, retorna false
      if (opcoesClassificadas < totalOpcoes) {
        return false;
      }
    }

    return true;
  };

  // Função para verificar se o botão salvar deve estar habilitado
  const botaoSalvarHabilitado = () => {
    if (temResposta) return false;

    // Verifica se todas as prioridades do tipo 14 estão marcadas
    if (!verificarPrioridadesCompletas()) {
      return false;
    }

    // Validar apenas perguntas obrigatórias E visíveis
    const perguntasObrigatorias = listaPesquisa?.perguntas?.filter(
      (p) => p.obrigatoria && perguntasVisiveis.has(p.id)
    ) || [];

    for (const pergunta of perguntasObrigatorias) {
      const resposta = respostas[pergunta.id];

      if (!resposta) return false;

      // Verifica se a pergunta foi respondida baseada no tipo
      if (pergunta.tipo === 10 || pergunta.tipo === 11) {
        if (!resposta.opcoes || resposta.opcoes.length === 0) return false;
      } else if (pergunta.tipo === 12) {
        if (!resposta.escala || resposta.escala === 0) return false;
      } else if (pergunta.tipo === 13) {
        if (!resposta.texto || resposta.texto.trim() === "") return false;
      } else if (pergunta.tipo === 14) {
        const classificacoes = resposta.classificacoes || {};
        if (Object.keys(classificacoes).length < pergunta.opcoes.length)
          return false;
      } else if (pergunta.tipo === 15) {
        if (resposta.respostaCondicional === undefined) return false;
      }
    }

    return true;
  };

  const salvarRespostas = async () => {
    const obj = {
      pesquisaId: params.id,
      respostas: Object.keys(respostas)
        .filter(perguntaId => perguntasVisiveis.has(perguntaId)) // Filtrar apenas visíveis
        .map((perguntaId) => {
          const pergunta = listaPesquisa.perguntas.find(
            (p) => p.id === perguntaId
          );
          const resposta = {
            perguntaId,
            texto: respostas[perguntaId]?.texto || "",
            escala: respostas[perguntaId]?.escala || 0,
            opcoes: respostas[perguntaId]?.opcoes || [],
          };

          // Adiciona classificações se for tipo 14
          if (pergunta?.tipo === 14 && respostas[perguntaId]?.classificacoes) {
            resposta.classificacoes = respostas[perguntaId].classificacoes;
          }
          
          // Adiciona resposta condicional se for tipo 15
          if (pergunta?.tipo === 15 && respostas[perguntaId]?.respostaCondicional !== undefined) {
            resposta.respostaCondicional = respostas[perguntaId].respostaCondicional;
          }

          return resposta;
        }),
    };
    setLoad(true);

    try {
      const response = await ApiServices.apiPost(`pesquisa/resposta`, obj);

      if (response.statusCode === 200) {
        toast.success(response.data);
        voltar();
      } else {
        toast.warning(response.message || "Erro ao salvar respostas");
      }
    } catch (error) {
      toast.error("Ocorreu um erro ao salvar as respostas");
    } finally {
      setLoad(false);
    }
  };

  const voltar = () => {
    navigate("/pesquisa");
  };

  return (
    <div className="container">
      <h2 className="mt-5 mb-4">Pesquisa</h2>
      <h4 className="mb-3" style={{ color: "#1a5940", fontWeight: 600 }}>{listaPesquisa?.titulo}</h4>
      {listaPesquisa?.descricao && (
        <p className="pesquisa-descricao">{listaPesquisa?.descricao}</p>
      )}
      <div className="pesquisa-aviso">
        <span style={{ fontWeight: 600 }}>
          ⚠️ Perguntas com * indicam que a resposta é obrigatória.
        </span>
      </div>

      <div className="row p-0">
        {listaPesquisa?.perguntas
          ?.sort((a, b) => a.ordem - b.ordem)
          .filter(pergunta => perguntasVisiveis.has(pergunta.id))
          .map((pergunta) => (
          <div key={pergunta.id} style={{ padding: "0" }}>
            {pergunta.tipo === 10 && (
              <div className="caixaResposta col-md-12">
                <div>
                  {pergunta.titulo}{" "}
                  {pergunta.obrigatoria && (
                    <span style={{ color: "red" }}>*</span>
                  )}
                  {pergunta.temLimiteResposta && pergunta.limiteResposta && (
                    <span
                      style={{
                        color: "#666",
                        fontSize: "0.9em",
                        marginLeft: "10px",
                      }}
                    >
                      (Máximo {pergunta.limiteResposta} 
                      {pergunta.limiteResposta > 1 ? "opções" : "opção"})
                    </span>
                  )}
                </div>
                {pergunta.opcoes.map((opcao) => (
                  <div key={opcao.id} style={{ marginBottom: "4px" }}>
                    <div className="d-flex align-items-center">
                      <Checkbox
                        disabled={isCheckboxDisabled(pergunta, opcao.id)}
                        checked={
                          respostas[pergunta.id]?.opcoes?.includes(opcao.id) ??
                          false
                        }
                        onChange={(e) =>
                          handleCheckboxChange(
                            pergunta.id,
                            opcao.id,
                            e.target.checked
                          )
                        }
                        value={opcao.id}
                        sx={{
                          "&.Mui-checked": {
                            color: "#00593d",
                          },
                          "&.Mui-disabled": {
                            color: "#ccc",
                          },
                          padding: "4px",
                        }}
                      />
                      <span className="ms-2" style={{ lineHeight: "1.5" }}>{opcao.texto}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {pergunta.tipo === 11 && (
              <div className="caixaResposta col-md-12">
                <div>
                  {pergunta.titulo}{" "}
                  {pergunta.obrigatoria && (
                    <span style={{ color: "red" }}>*</span>
                  )}
                </div>
                <RadioGroup
                  value={respostas[pergunta.id]?.opcoes?.[0] || ""}
                  onChange={(e) =>
                    handleRadioChange(pergunta.id, e.target.value)
                  }
                  disabled={temResposta}
                >
                  {pergunta.opcoes.map((opcao) => (
                    <FormControlLabel
                      key={opcao.id}
                      value={opcao.id}
                      control={
                        <Radio
                          color="primary"
                          sx={{
                            "&.Mui-checked": {
                              color: "#00593d",
                            },
                          }}
                          disabled={temResposta}
                        />
                      }
                      label={opcao.texto}
                    />
                  ))}
                </RadioGroup>
              </div>
            )}

            {pergunta.tipo === 12 && (
              <div>
                <div>
                  {pergunta.titulo}{" "}
                  {pergunta.obrigatoria && (
                    <span style={{ color: "red" }}>*</span>
                  )}
                </div>
                <div className="d-flex justify-content-center">
                  <span className="me-2 mt-3">
                    {pergunta.textoEscalaInicial}
                  </span>
                  {js
                    .filter(
                      (item) =>
                        item.nome >= pergunta.numeroInicialEscala &&
                        item.nome <= pergunta.numeroFinalEscala
                    )
                    .map((item) => (
                      <div
                        key={item.id}
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          width: 50,
                          height: 50,
                          backgroundColor: item.cores,
                          fontSize: 30,
                          fontWeight: "bold",
                          color: "#fff",
                          borderRadius: 10,
                          margin: 5,
                          cursor: temResposta ? "not-allowed" : "pointer",
                          border:
                            respostas[pergunta.id]?.escala === item.nome
                              ? "4px solid #1d5840"
                              : "none",
                        }}
                        onClick={() =>
                          !temResposta &&
                          handleEscalaChange(pergunta.id, item.nome)
                        }
                      >
                        {item.nome}
                      </div>
                    ))}{" "}
                  <span className="ms-2 mt-3">{pergunta.textoEscalaFinal}</span>
                </div>
              </div>
            )}

            {pergunta.tipo === 13 && (
              <div className="caixaResposta col-md-12">
                <div>
                  {pergunta.titulo}{" "}
                  {pergunta.obrigatoria && (
                    <span style={{ color: "red" }}>*</span>
                  )}
                </div>
                <textarea
                  rows="4"
                  cols="50"
                  style={{ width: "100%" }}
                  disabled={temResposta}
                  value={respostas[pergunta.id]?.texto || ""}
                  onChange={(e) =>
                    handleTextareaChange(pergunta.id, e.target.value)
                  }
                ></textarea>
              </div>
            )}

            {pergunta.tipo === 14 && (
              <div className="caixaResposta col-md-12">
                <div>
                  {pergunta.titulo}{" "}
                  {pergunta.obrigatoria && (
                    <span style={{ color: "red" }}>*</span>
                  )}
                  <span
                    style={{
                      color: "#666",
                      fontSize: "0.9em",
                      marginLeft: "10px",
                    }}
                  >
                    (Clique para classificar por prioridade)
                  </span>
                </div>
                <div className="mt-3">
                  {pergunta.opcoes.map((opcao) => {
                    const prioridade = getPrioridade(pergunta.id, opcao.id);
                    return (
                      <div key={opcao.id} className="mb-2">
                        <div
                          className="d-flex align-items-center p-3 border rounded"
                          style={{
                            backgroundColor: prioridade ? "#e6f0e7" : "#f8f9fa",
                            borderColor: prioridade ? "#00593d" : "#dee2e6",
                            cursor: temResposta ? "not-allowed" : "pointer",
                            transition: "all 0.2s ease",
                          }}
                          onClick={() =>
                            !temResposta &&
                            handleClassificacaoChange(pergunta.id, opcao.id)
                          }
                        >
                          <div
                            className="d-flex align-items-center justify-content-center me-3"
                            style={{
                              width: 40,
                              height: 40,
                              backgroundColor: prioridade
                                ? "#00593d"
                                : "#6c757d",
                              color: "white",
                              borderRadius: "50%",
                              fontSize: "1.2em",
                              fontWeight: "bold",
                            }}
                          >
                            {prioridade || "?"}
                          </div>
                          <span className="flex-grow-1">{opcao.texto}</span>
                          {prioridade && (
                            <span className="badge" style={{ backgroundColor: "#00593d", color: "white" }}>
                              Prioridade {prioridade}
                            </span>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {pergunta.tipo === 15 && (
              <div className="caixaResposta col-md-12">
                <div>
                  {pergunta.titulo}{" "}
                  {pergunta.obrigatoria && (
                    <span style={{ color: "red" }}>*</span>
                  )}
                </div>
                <RadioGroup
                  value={
                    respostas[pergunta.id]?.respostaCondicional === true
                      ? "sim"
                      : respostas[pergunta.id]?.respostaCondicional === false
                      ? "nao"
                      : ""
                  }
                  onChange={(e) =>
                    handleCondicionalChange(
                      pergunta.id,
                      e.target.value === "sim"
                    )
                  }
                  disabled={temResposta}
                >
                  <FormControlLabel
                    value="sim"
                    control={
                      <Radio
                        color="primary"
                        sx={{
                          "&.Mui-checked": {
                            color: "#00593d",
                          },
                        }}
                        disabled={temResposta}
                      />
                    }
                    label="Sim"
                  />
                  <FormControlLabel
                    value="nao"
                    control={
                      <Radio
                        color="primary"
                        sx={{
                          "&.Mui-checked": {
                            color: "#00593d",
                          },
                        }}
                        disabled={temResposta}
                      />
                    }
                    label="Não"
                  />
                </RadioGroup>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="row d-flex justify-content-center my-5">
        <div className="col-md-4 p-2">
          <button className="btn btn-secondary w-100" onClick={voltar}>
            Voltar
          </button>
        </div>
        {!temResposta && (
          <div className="col-md-4 p-2">
            <button
              className={`btn w-100 ${
                botaoSalvarHabilitado() ? "btn-warning" : "btn-secondary"
              }`}
              onClick={salvarRespostas}
              disabled={!botaoSalvarHabilitado()}
            >
              Salvar
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
